import React, { ReactElement } from 'react';
import styled from 'styled-components';
import vars from '../assets/overwrite-vars.scss';
import { Click, ClickLink as CommonClickLink } from './Common';

const ClickLinkWrapper = styled.span`
  a:first-child {
    color: ${vars.primary};
    text-decoration: underline;
  }
`;

const ClickLink = (props: Click): ReactElement => {
  return (
    <ClickLinkWrapper>
      <CommonClickLink {...props} />
    </ClickLinkWrapper>
  );
};

export default ClickLink;
